import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  tableContainer: {
    '& .MuiTableCell-root': {
      padding: '18px 13px'
    },
    '& .MuiTableRow-head': {
      '& th:first-child': {
        paddingLeft: '24px'
      },
      '& th:last-child': {
        paddingRight: '24px'
      }
    },
    '& .MuiTableBody-root': {
      '& td:first-child': {
        paddingLeft: '24px'
      },
      '& td:last-child': {
        paddingRight: '24px'
      }
    }
  },
  firstCell: {
    width: '400px'
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  addressField: {
    marginLeft: '20px'
  },
  statusField: {
    marginLeft: '10px'
  },
  lastCell: {
    width: '135px'
  },
  actions: {
    marginLeft: '4px'
  }
});
export default useStyles;